import { render } from "./WSetting.vue?vue&type=template&id=d0aefa80&scoped=true"
import script from "./WSetting.vue?vue&type=script&lang=js"
export * from "./WSetting.vue?vue&type=script&lang=js"

import "./WSetting.vue?vue&type=style&index=0&id=d0aefa80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0aefa80"]])

export default __exports__